<template>
  <div
    class="entry-form"
    :class="{ 'is-active': form.id === currentProjectForm.id }"
    @click="$store.commit('setCurrentProjectFormId', form.id)"
  >
    <div class="entry-form__name">{{ form.form_name }}</div>
    <div class="entry-form__count">{{ form.submissions_count }}/{{ form.submissions_full_count }}</div>
  </div>
</template>

<script>
export default {
  name: 'entry-form',
  props: {
    form: Object
  },
  computed: {
    currentProjectForm() {
      return this.$store.getters.currentProjectForm || {}
    }
  }
}
</script>

<style lang="scss">
.entry-form {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem 0.5rem 0.75rem;
  cursor: pointer;
  transition: 0.2s;
  &:last-child {
    margin-bottom: 0.5rem;
  }
  &__name {
    padding-right: 8px;
    overflow: hidden;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__count {
    margin-left: auto;
    padding: 4px 6px;
    color: $white;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    background-color: rgba($white, 0.15);
    border-radius: $border-radius;
  }
  &:hover {
    background-color: rgba($white, 0.025);
  }
  &.is-active {
    background-color: rgba($white, 0.05);
  }
}
</style>
